var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"details"},[_c('Crumbs',{attrs:{"config":_vm.crumbsConfig}}),_c('div',{staticClass:"det_content"},[_c('Substance',{attrs:{"details":_vm.details}}),_c('Recommend',{attrs:{"details":_vm.details}})],1),(_vm.details.adsPojo!==null)?_c('Advert',{attrs:{"adsPojo":_vm.details.adsPojo}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }